import dayjs from 'dayjs'
import minBy from 'lodash/minBy'
import maxBy from 'lodash/maxBy'
import getOverlappingIndicesList from './getOverlappingIndicesList'

const getOverlappingPeriodsList = campaignBudgets =>
  getOverlappingIndicesList(campaignBudgets).map((indices, index) => {
    const campaignBudget = campaignBudgets[index]
    return indices.map(otherIndex => {
      const otherCampaignBudget = campaignBudgets[otherIndex]
      const start = maxBy(
        [campaignBudget.startTime, otherCampaignBudget.startTime],
        time => dayjs(time).unix(),
      )
      const end = minBy(
        [campaignBudget.endTime, otherCampaignBudget.endTime],
        time => dayjs(time).unix(),
      )
      const length = dayjs(end).diff(start, 'second')
      return {
        start,
        end,
        length,
      }
    })
  })

export default getOverlappingPeriodsList
